import subYears from 'date-fns/subYears'

export const TODAY = new Date().setHours(0, 0, 0, 0)
export const TWO_YEARS_AGO = subYears(TODAY, 2)
